export default __webpack_public_path__ + "static/male3-90e9af19d804bd74c281405845d20155.png";